import { Injectable } from '@angular/core';
import { AbstractEntityStore } from '@pf/shared-services';
import { PFWmsEntities } from '@pf/shared-common';
import { WarehouseRead } from '../../entities/warehouse.dto';
import { localStorageStrategy, persistState } from '@ngneat/elf-persist-state';

@Injectable()
export class WarehouseStore extends AbstractEntityStore<WarehouseRead> {
    constructor() {
        super(PFWmsEntities.Warehouse);

        persistState(this._store, {
            storage: localStorageStrategy,
        });
    }
}
